import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as selectores from "app/features/selectores/index";
import { fa } from "typed-font-awesome";

type Entity = models.ServiciosAdicionalesTarifaPP;
interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
    readonly?: boolean;
}
export class ServiciosAdicionales extends React.PureComponent<Props> {
    errors = () => kea.validation.getErrors(this.rules, this.props.value);
    getField = kea.formfields(() => this.props, this.errors);
    readonly = (x: Props) => x.readonly;

    get rules(): kea.validation.Rules<Entity> {
        return {};
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;
        const readonly = this.readonly(this.props);

        const Check = getField(kea.Checkbox);
        const TipoAcuse = getField(selectores.TipoAcuse);
        const Number = getField(kea.Number);

        return (
            <kea.Panel iconClass={fa("plus")} title="Servicios adicionales" >
                {kea.autogrid(6, [
                    <Check field="EntregaDomicilio" label="Entrega a domicilio" readonly={readonly} />,
                    <Check field="RecoleccionDomicilio" label="RecoleccionDomicilio" readonly={readonly} />,
                    <TipoAcuse field="Acuse" label="Tipo de acuse" readonly={readonly} />,
                    <Number field="ValorDeclarado" label="Valor declarado" format="currency" readonly={readonly} />,
                    <Number field="ValorFactura" label="Valor factura" format="currency" readonly={readonly} />
                ])}
            </kea.Panel>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifaPP/edit/servadic.tsx